import { handleUrl, myHeadersWithToken } from '../../global';
import { GetLastMessagesResponse } from './types';

export const getLastMessages = (
  page: number,
  size: number
): Promise<GetLastMessagesResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/hive-messages?page=${page}&size=${size}&sender=worker`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
